// src/pages/Login.js
import React from "react";
import AuthForm from "../components/AuthForm";

const Login = () => <AuthForm isLogin={true} />;
export default Login;